import React from 'react';
import { Steps as AntSteps } from 'antd';

/**
 * Wrapper component for Ant Design Steps
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Steps functionality and sub-components.
 * 
 * @component
 * @example
 * import { Steps } from '../GeneralComponents/ui';
 * 
 * const { Step } = Steps;
 * <Steps current={1}>
 *   <Step title="Finished" description="This is a description." />
 *   <Step title="In Progress" description="This is a description." />
 *   <Step title="Waiting" description="This is a description." />
 * </Steps>
 * 
 * @see https://ant.design/components/steps/ - Ant Design Steps documentation
 */
const Steps = (props) => {
  return <AntSteps {...props} />;
};

// Preserve Steps sub-components
Steps.Step = AntSteps.Step;

export default Steps;

